import { stockTypeEnum } from "@gtpl/shared-models/common-models";
import { IndentFormDto } from "./dto/indent-form.dto";
import { PackingIndent } from "./packing-indent.entity";

export class IndentFormAdapter{
    convertDtoToEntity(dtoObj:IndentFormDto,  isUpdate: boolean = false):PackingIndent{
        const entityObj = new PackingIndent();
        entityObj.indentFormId = dtoObj.indentFormId;
        entityObj.stockType = dtoObj.stockType;
        entityObj.saleOrderId = dtoObj.saleOrderId;
        entityObj.saleOrderItemId = dtoObj.saleOrderItemId;
        entityObj.itemId = dtoObj.itemId;
        entityObj.quantity = dtoObj.quantity;
        entityObj.unitId = dtoObj.unitId;
        entityObj.createdAt = dtoObj.createdAt;
        entityObj.updatedAt = dtoObj.updatedAt;
        entityObj.createdUser = dtoObj.createdUser;
        entityObj.updatedUser = dtoObj.updatedUser;
        entityObj.versionFlag = dtoObj.versionFlag;
        entityObj.indentNumber = dtoObj.indentNumber;
        entityObj.barcode = dtoObj.barcode
        entityObj.status=dtoObj.status;
        entityObj.receivedQuantity=dtoObj.receivedQuantity;
        entityObj.issuedQuantity=dtoObj.issuedQuantity;
        return entityObj
    }

     public convertEntityToDto(obj:PackingIndent) : IndentFormDto{
        const dtoObj = new IndentFormDto;

        dtoObj.indentFormId = obj.indentFormId; 
        dtoObj.stockType = obj.stockType;
        dtoObj.saleOrderId = obj.saleOrderId;
        dtoObj.itemId = obj.itemId;
        dtoObj.quantity = obj.quantity;
        dtoObj.unitId = obj.unitId;
        dtoObj.createdAt = obj.createdAt;
        dtoObj.updatedAt = obj.updatedAt;
        dtoObj.createdUser = obj.createdUser;
        dtoObj.updatedUser = obj.updatedUser;
        dtoObj.versionFlag = obj.versionFlag;
        dtoObj.indentNumber = obj.indentNumber;
        dtoObj.status=obj.status;
        dtoObj.receivedQuantity=obj.receivedQuantity;
        dtoObj.issuedQuantity=obj.issuedQuantity;
        return dtoObj;
     }
}